import styled, { keyframes } from "styled-components";
import { QRCodeSVG } from "qrcode.react";

import { ReactComponent as MainLogoSVG } from "../assets/heraldic-logo.svg";
import { ReactComponent as MainLogoInvSVG } from "../assets/heraldic-logo_inverse.svg";
import { ReactComponent as MainPoweredByLogoSVG } from "../assets/powered-by-indicio_logo.svg";

import { ReactComponent as AccountSVG } from "../assets/account-icon.svg";
import { ReactComponent as FacebookSVG } from "../assets/facebook-icon.svg";
import { ReactComponent as TwitterSVG } from "../assets/x-icon.svg";
import { ReactComponent as LinkedInSVG } from "../assets/linkedin-icon.svg";

export const Frame = styled.div`
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

//Header styles
export const HeaderMain = styled.header`
  width: 100%;
  height: clamp(8vh, 10vh, 12vh);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.reqWhite};

  > nav {
    height: 100%;
    width: 1150px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      width: 100%;
      padding: 0 2rem;
    }

    > span {
      display: flex;
      align-items: center;
      width: 40%;
      height: 100%;

      :hover {
        cursor: pointer;
      }
    }
  }
`;
export const HeaderOptions = styled.div`
  display: flex;
  flex: 1;
  max-width: 70%;
  justify-content: space-between;
  align-items: center;
  
  a {
    text-decoration: none;
  }

  span {
    text-transform: uppercase;
    font-weight: 600;
    font-family: "REM" sans-serif;
    font-size: 1rem;

    :hover {
      cursor: pointer;
    }
  }
  span:nth-of-type(5) {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      margin-left: 5px;
    }
  }
`;

// Main styles
export const Main = styled.main`
  min-height: 60vh;
  background: linear-gradient(180deg, #ffffff 0%, #fff8d9 100%);
`;

// Footer styles
export const FooterMain = styled.footer`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: ${(props) => props.theme.regBlack};
  color: ${(props) => props.theme.regWhite};

  > div {
    width: 100%;
    height: clamp(250px, 30vh, 280px);
    width: 1150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.8rem 0 1.8rem 0;

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      height: 210px;
      width: 100%;
      padding: 1.8rem 2rem;
    }
  }

  p {
    font-size: 0.7rem;
  }
`;
export const FooterMainFirst = styled.div`
  height: 100%;
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  > div {
    width: 80%;

    div {
      width: 100%;
    }
    div:first-child {
      margin-bottom: 10px;
    }
  }
  > span {
    width: 100%;

    p:nth-of-type(1) {
      margin-bottom: 10px;
    }
  }
`;
export const FooterMainSecond = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100%;
    width: 20%;

    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 22%;

      p {
        margin-bottom: 5px;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
      }

      span {
        width: 60%;
        border-bottom: 4px solid ${(props) => props.theme.primaryYellow};
        border-radius: 10px;
      }
    }

    a {
      text-decoration: none;
      color: ${(props) => props.theme.regWhite};
      font-size: 0.7rem;
      margin-bottom: 0.8rem;
      white-space: nowrap;
    }
  }
`;
export const FooterMainThird = styled.div`
  height: 100%;
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  > div:nth-of-type(1) {
    width: 100%;

    button {
      width: 100%;
      height: 70%;
      border-radius: 10px;
      font-size: 0.9rem;
      font-weight: bold;
      text-transform: uppercase;
    }
    button:nth-of-type(1) {
      background-color: ${(props) => props.theme.regBlack};
      color: ${(props) => props.theme.primaryYellow};
      border: 2px solid ${(props) => props.theme.primaryYellow};
      margin-bottom: 10px;

      span {
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          text-transform: uppercase;
          margin-left: 5px;
          font-size: 0.9rem;
          font-weight: bold;
        }
      }
    }
    button:nth-of-type(2) {
      background-color: ${(props) => props.theme.regWhite};
      color: ${(props) => props.theme.regBlack};
      border: 2px solid ${(props) => props.theme.reqWhite};
    }
  }

  > div:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      font-size: 1rem;
      margin-bottom: 5px;
      text-transform: uppercase;
      font-weight: bold;
      color: ${(props) => props.theme.primaryYellow};
    }

    span {
      display: flex;

      * {
        margin-right: 10px;
      }
    }
  }
`;

// Global styles
export const SubHeader = styled.header`
  width: 100%;
  height: clamp(60px, 8vh, 80px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${(props) => props.theme.regBlack};
  color: ${(props) => props.theme.regWhite};
  margin-bottom: clamp(4.2rem, 8vh, 6rem);

  p {
    width: 1150px;
    font-size: 0.8rem;

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      width: 100%;
      padding: 0 2rem;
    }
  }
`;
export const QRCode = styled(QRCodeSVG)`
  width: 100%;
  height: 100%;
`;

const rotate = keyframes`
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
`;
export const LoadingSpinner = styled.span`
  width: 50%;
  aspect-ratio: 1 / 1;
  border: 10px solid ${(props) => props.theme.regBlack};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;

// Logo and Icons
export const MainLogo = styled(MainLogoSVG)`
  width: inherit;
  height: auto;
`;
export const MainLogoInverted = styled(MainLogoInvSVG)`
  width: inherit;
  height: auto;
`;
export const MainPoweredByLogo = styled(MainPoweredByLogoSVG)`
  width: inherit;
  height: auto;
`;

export const AccountIcon = styled(AccountSVG)`
  width: 1rem;
  height: auto;
`;
export const FacebookIcon = styled(FacebookSVG)`
  width: 1rem;
  height: auto;
`;
export const TwitterIcon = styled(TwitterSVG)`
  width: 1rem;
  height: auto;
`;
export const LinkedInIcon = styled(LinkedInSVG)`
  width: 1rem;
  height: auto;
`;
